import React from "react";
import PropTypes from "prop-types";

import BaseSkeleton from "components/Skeleton/BaseSkeleton";
import {
  SkeletonActions,
  SkeletonCard,
  SkeletonCardOverlay,
  SkeletonGrid,
  SkeletonHeader,
  SkeletonHeaderMain,
  SkeletonRoot,
} from "./styled";

export default function CatalogSkeleton({ cards, showFilters }) {
  return (
    <SkeletonRoot>
      <SkeletonHeader>
        <SkeletonHeaderMain>
          <BaseSkeleton height={12} width={138} />
          <BaseSkeleton height={42} width="min(420px, 72vw)" />
        </SkeletonHeaderMain>

        <SkeletonActions>
          {showFilters ? <BaseSkeleton height={44} width={122} borderRadius={999} /> : null}
          <BaseSkeleton height={44} width={96} borderRadius={999} />
          <BaseSkeleton height={44} width={112} borderRadius={999} />
        </SkeletonActions>
      </SkeletonHeader>

      <SkeletonGrid>
        {Array.from({ length: cards }).map((_, index) => (
          <SkeletonCard key={index}>
            <BaseSkeleton height="100%" width="100%" borderRadius={20} />

            <SkeletonCardOverlay>
              <BaseSkeleton height={22} width={index % 2 === 0 ? "68%" : "56%"} />
              <BaseSkeleton height={16} width={index % 3 === 0 ? "34%" : "42%"} />
            </SkeletonCardOverlay>
          </SkeletonCard>
        ))}
      </SkeletonGrid>
    </SkeletonRoot>
  );
}

CatalogSkeleton.propTypes = {
  cards: PropTypes.number,
  showFilters: PropTypes.bool,
};

CatalogSkeleton.defaultProps = {
  cards: 6,
  showFilters: true,
};
